export function thousandsFmt(num) {
  if (num === null || num === undefined) {
    return '';
  }
  return (num || 0).toString(10).replace(/(\d{1,3})(?=(\d{3})+$)/g, '$1,');
}

/**
 * 将object转换为FormData
 * @param {*} data - 目标object
 */
export function toFormData(data) {
  const formData = new FormData();
  Object.keys(data).forEach((key) => {
    formData.append(key, data[key]);
  });
  return formData;
}

/**
 * 判断目标值是否为空
 * @param {*} val
 */
export function isEmpty(val) {
  return !(val || val === false || val === 0);
}

/**
 * 格式化日期
 * @param {Date|Number|String} dateVal - 时间
 * @param {string} formatter - 格式，默认为'yyyy-MM-dd HH:mm:ss'
 */
export function dateFormat(dateVal, formatter = 'yyyy-MM-dd HH:mm:ss') {
  const date = new Date(dateVal);

  let fmt = formatter;
  const o = {
    'M+': date.getMonth() + 1, // 月份
    '[Dd]+': date.getDate(), // 日
    '[Hh]+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds(), // 毫秒
  };

  if (/([Yy]+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, `${date.getFullYear()}`.substr(4 - RegExp.$1.length));
  }

  Object.keys(o).forEach((k) => {
    if (new RegExp(`(${k})`).test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : `00${o[k]}`.substr(`${o[k]}`.length));
    }
  });

  return fmt;
}

export const distinct = (arr, key) => {
  const result = {};
  return arr.filter((p) => {
    const val = key ? p[key] : p;
    if (result[val]) {
      return false;
    }
    result[val] = true;
    return true;
  });
};

/**
 * 向input中插入文字
 * @param {HTMLElement} element - input元素
 * @param {string} str - 待插入字符串
 * @returns {string} - 返回完整字符串
 */
export const insertText = (element, str) => {
  if (typeof element.selectionStart === 'number' && typeof element.selectionEnd === 'number') {
    const startPos = element.selectionStart;
    const endPos = element.selectionEnd;
    const tmpStr = element.value;
    return tmpStr.substring(0, startPos) + str + tmpStr.substring(endPos, tmpStr.length);
  }
  return element.value + str;
};

export function debounce(func, wait) {
  let timeout;
  let res;
  return function unname() {
    const that = this;
    // eslint-disable-next-line prefer-rest-params
    const args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      res = func.apply(that, args);
    }, wait);
    return res;
  };
}

export function num2Chinese(n) {
  switch (n) {
    case 1:
      return '一';
    case 2:
      return '二';
    case 3:
      return '三';
    case 4:
      return '四';
    default:
      return n;
  }
}

export function bool2Chinese(boolean) {
  if (boolean) {
    return '是';
  }
  return '否';
}

// 笛卡尔积：https://blog.csdn.net/maxsky/article/details/80196323
export function calcDescartes(array) {
  if (array.length < 2) return array[0] || [];
  return [].reduce.call(array, (col, set) => {
    const res = [];
    col.forEach((c) => {
      set.forEach((s) => {
        const t = [].concat(Array.isArray(c) ? c : [c]);
        t.push(s);
        res.push(t);
      });
    });
    return res;
  });
}
// console.log(calcDescartes([[1,2,3],['a','b','c']]));

export function timeout(callback, ms, arg) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(callback(arg));
    }, ms);
  });
}

export function filterParams(obj) {
  if (!obj) return {};
  Object.keys(obj).forEach((item) => {
    if (obj[item] === null || obj[item] === undefined || obj[item] === '') delete obj[item];
  });
  return obj;
}
